// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3BxxS","label":"CategoryService_label__RxJCC","location":"CategoryService_location__2888-"};